import { create } from 'zustand'
import { createAuthSlice, type AuthSlice } from './slices/auth'
import { createPersonalSlice, type PersonalSlice } from './slices/personal'
import { createSystemSlice, type SystemSlice } from './slices/system'
import { createUiSlice, type UiSlice } from './slices/ui'

export interface AppStore {
  auth: AuthSlice
  personal: PersonalSlice
  system: SystemSlice
  ui: UiSlice
}

export const useStore = create<AppStore>()((...a) => ({
  ...createAuthSlice(...a),
  ...createPersonalSlice(...a),
  ...createSystemSlice(...a),
  ...createUiSlice(...a),
}))
